import { useSidebarAnimation } from "@/hooks/use-sidebar-animation";
import { EpisodeListPage } from "@/pages/episodes/EpisodeListPage";
import { EpisodePage } from "@/pages/episodes/EpisodePage";
import { ImagePage } from "@/pages/images/ImagePage";
import { ManualEditListPage } from "@/pages/images/ManualEditListPage";
import { MaskPage } from "@/pages/images/MaskPage";
import { LoginPage } from "@/pages/LoginPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PromptListPage } from "@/pages/prompts/PromptListPage";
import { PromptPage } from "@/pages/prompts/PromptPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { StoryConfigListPage } from "@/pages/story-configs/StoryConfigListPage";
import { StoryConfigPage } from "@/pages/story-configs/StoryConfigPage";
import { StoryGenerationPage } from "@/pages/StoryGenerationPage";
import { SubmissionPage } from "@/pages/SubmissionPage";
import { ValidationPage } from "@/pages/ValidationPage";
import { useHandleUnauthenticated } from "@/queries/auth";
import { Container } from "@mui/material";
import { Navigate, Route, Routes } from "react-router";
import { MasterCombinationListPage } from "./MasterCombinationListPage";

export function Pages() {
  useHandleUnauthenticated();

  const sidebarAnimationSx = useSidebarAnimation();

  return (
    <Container
      maxWidth={false}
      sx={{
        mt: 8,
        ...sidebarAnimationSx,
      }}
    >
      <Routes>
        <Route path="/" element={<Navigate replace to="/episodes" />} />
        <Route path="/episodes" element={<EpisodeListPage />} />
        <Route path="/episodes/:id" element={<EpisodePage />} />
        <Route path="/images/:id" element={<ImagePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/manual-edit" element={<ManualEditListPage />} />
        <Route path="/masks/:id" element={<MaskPage />} />
        <Route
          path="/master-combinations"
          element={<MasterCombinationListPage />}
        />
        <Route path="/prompts" element={<PromptListPage />} />
        <Route path="/prompts/:id" element={<PromptPage />} />
        <Route
          path="/prompts/:id/revisions/:revisionNumber"
          element={<PromptPage />}
        />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/story-configs" element={<StoryConfigListPage />} />
        <Route path="/story-configs/:id" element={<StoryConfigPage />} />
        <Route
          path="/story-configs/:id/revisions/:revisionNumber"
          element={<StoryConfigPage />}
        />
        <Route path="/story-generator" element={<StoryGenerationPage />} />
        <Route path="/submit" element={<SubmissionPage />} />
        <Route path="/validate" element={<ValidationPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Container>
  );
}
